module.exports = __webpack_public_path__ + "img/1474507473.90755e19.jpg";